/* ============================================================================
   sgp-fiche.js : le comportement de la fiche produit Storegen à paliers,
   28/09/2026.

   Ce que ce fichier fait, et rien d'autre :
   · offre à paliers : total, prix à l'unité et économie CALCULÉS sur le prix de
     la variante choisie (calculPalier), jamais saisis ;
   · choix de variante, et un article par ligne dès 2 articles : la couleur et la
     taille du haut sont recopiées sur chaque ligne que le client n'a pas touchée ;
   · ajout au panier en UNE requête (/cart/add.js, forme { items: [...] }), puis
     ouverture du tiroir du thème (window.SGCart) ;
   · galerie au doigt et vignettes ; date d'expédition sans compte à rebours ;
   · barre collante visible dès que le bouton d'achat est sorti de l'écran par le
     haut, même après un SAUT par-dessus (ancre, retour de page) : un écouteur de
     défilement, pas un IntersectionObserver, qui ne voit pas les sauts ;
   · guide des tailles : tableau, calculateur qui propose puis COCHE la taille ;
   · vidéos : adresse posée seulement quand le bloc arrive à l'écran, pause dès
     qu'il en sort, jamais deux lectures ensemble.
   · avis (V2, lot 3) : la piste défile comme la bande de photos ; un texte long
     replié s'ouvre par « Lire la suite », montré seulement s'il est coupé.

   Le fichier peut être chargé par plusieurs sections : il ne s'exécute qu'une fois.
   Les noeuds sont cherchés au moment de s'en servir, jamais retenus à l'analyse
   (leçon du 22/09 : un script posé avant son formulaire le rate en silence).
   ============================================================================ */
(function () {
  "use strict";
  if (window.SgpFiche) return;

  var NBSP = "\u00a0";
  var reduit = false;
  try { reduit = window.matchMedia("(prefers-reduced-motion: reduce)").matches; } catch (e) {}

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  /* ── LE formateur de prix, jumeau de snippets/sgp-prix.liquid ──────────────
     En euros : « 1 234,50 € » (espaces insécables), quel que soit le format de la
     boutique. Autre devise : le format de la boutique, lu comme le fait le tiroir. */
  function prix(c, devise, format) {
    c = Math.round(Number(c) || 0);
    if (!devise || devise === "EUR") {
      var e = Math.floor(c / 100), d = String(c % 100);
      if (d.length < 2) d = "0" + d;
      return String(e).replace(/\B(?=(\d{3})+(?!\d))/g, NBSP) + "," + d + NBSP + "\u20ac";
    }
    var f = String(format || "{{amount}}");
    var m = f.match(/\{\{\s*(\w+)\s*\}\}/), cle = m ? m[1] : "amount";
    function fmt(n, p, t, s) {
      var parts = (n / 100).toFixed(p).split(".");
      return parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + t) + (parts[1] ? s + parts[1] : "");
    }
    var v;
    switch (cle) {
      case "amount_no_decimals": v = fmt(c, 0, ",", "."); break;
      case "amount_with_comma_separator": v = fmt(c, 2, ".", ","); break;
      case "amount_no_decimals_with_comma_separator": v = fmt(c, 0, ".", ","); break;
      case "amount_with_space_separator": v = fmt(c, 2, " ", ","); break;
      case "amount_with_apostrophe_separator": v = fmt(c, 2, "'", "."); break;
      default: v = fmt(c, 2, ",", ".");
    }
    return f.replace(/\{\{\s*\w+\s*\}\}/, v);
  }

  /* ── Le calcul d'un palier, jumeau du Liquid de sections/sgp-fiche.liquid ──
     total = prix × quantité × (100 − remise) / 100, arrondi au centime ;
     unité = total / quantité ; économie = prix × quantité − total.
     La remise n'est jamais inventée : 0 par défaut, et elle doit correspondre à
     une remise automatique réelle de la boutique (réglage du palier). */
  function calculPalier(prixUnitaire, quantite, remise) {
    var p = Math.round(Number(prixUnitaire) || 0);
    var q = Math.max(1, Math.round(Number(quantite) || 1));
    var r = Math.min(100, Math.max(0, Number(remise) || 0));
    var brut = p * q;
    var total = Math.round(brut * (100 - r) / 100);
    return { total: total, unite: Math.round(total / q), economie: brut - total };
  }

  function racineShopify() {
    var r = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return typeof r === "string" && r ? r : "/";
  }

  /* ════════════════════════════ LA FICHE ════════════════════════════ */
  function Fiche(racine) {
    this.racine = racine;
    var brut = $("[data-sgp-donnees]", racine);
    this.D = brut ? JSON.parse(brut.textContent) : { options: [], variantes: [], textes: {} };
    this.T = this.D.textes || {};
    this.etat = { q: 1, remise: 0, options: [], articles: [] };
    racine.__sgp = this;
    this.initOffre();
    this.initGalerie();
    this.initExpedition();
    this.initBarre();
    this.initGuide();
  }

  Fiche.prototype.form = function () { return $("[data-sgp-offre]", this.racine); };
  Fiche.prototype.prix = function (c) { return prix(c, this.D.devise, this.D.format); };
  Fiche.prototype.nomQuantite = function (q) { return q + " " + (q > 1 ? this.D.nomPluriel : this.D.nomSingulier); };

  Fiche.prototype.variante = function (options) {
    var vs = this.D.variantes || [];
    if (!vs.length) return null;
    if (!(this.D.options || []).length) return vs[0];
    for (var i = 0; i < vs.length; i++) {
      var ok = true;
      for (var j = 0; j < options.length; j++) if (vs[i].options[j] !== options[j]) { ok = false; break; }
      if (ok) return vs[i];
    }
    return null;
  };

  /* ── Offre ─────────────────────────────────────────────────────────────── */
  Fiche.prototype.initOffre = function () {
    var self = this, form = this.form();
    if (!form) return;
    var coche = $('.sgp-palier input:checked', form);
    if (coche) { this.etat.q = +coche.value; this.etat.remise = +coche.getAttribute("data-remise") || 0; }
    this.etat.options = (this.D.options || []).map(function (o, i) {
      var c = $('input[data-sgp-option="' + i + '"]:checked', form);
      return c ? c.value : (o.valeurs[0] || "");
    });
    this.construireArticles();
    this.maj(false);

    form.addEventListener("change", function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.closest(".sgp-palier")) {
        self.etat.q = +t.value; self.etat.remise = +t.getAttribute("data-remise") || 0;
        self.construireArticles(); self.maj(false);
      } else if (t.hasAttribute("data-sgp-option")) {
        var i = +t.getAttribute("data-sgp-option");
        self.etat.options[i] = t.value;
        if (t.closest("[data-sgp-taille]")) { var cs = $("[data-sgp-conseil]", self.racine); if (cs && !t.__sgpCalcul) cs.hidden = true; }
        t.__sgpCalcul = false;
        self.recopier(); self.maj(true);
      } else if (t.hasAttribute("data-sgp-saisie-qte")) {
        self.etat.q = Math.max(1, Math.min(99, Math.round(+t.value) || 1)); t.value = self.etat.q; self.maj(false);
      }
    });
    $$("[data-sgp-pas-qte]", form).forEach(function (b) {
      b.addEventListener("click", function () {
        var champ = $("[data-sgp-saisie-qte]", form);
        self.etat.q = Math.max(1, Math.min(99, self.etat.q + (+b.getAttribute("data-sgp-pas-qte"))));
        if (champ) champ.value = self.etat.q;
        self.maj(false);
      });
    });
  };

  /* Les options qui méritent une liste par article : celles qui ont plusieurs valeurs. */
  Fiche.prototype.optionsVariables = function () {
    return (this.D.options || []).map(function (o, i) { return { nom: o.nom, valeurs: o.valeurs, i: i }; })
      .filter(function (o) { return o.valeurs.length > 1; });
  };

  Fiche.prototype.construireArticles = function () {
    var details = $("[data-sgp-articles]", this.racine), liste = $("[data-sgp-liste-articles]", this.racine);
    var ops = this.optionsVariables(), etat = this.etat, self = this;
    while (etat.articles.length < etat.q) etat.articles.push({ options: etat.options.slice(), touche: false });
    etat.articles.length = etat.q;
    if (!details || !liste || !ops.length) return;
    liste.textContent = "";
    etat.articles.forEach(function (a, n) {
      var ligne = document.createElement("div");
      ligne.className = "sgp-article";
      ligne.style.setProperty("--n", ops.length);
      var nom = document.createElement("span");
      nom.className = "sgp-article__nom";
      nom.textContent = self.T.article + " " + (n + 1);
      ligne.appendChild(nom);
      ops.forEach(function (o) {
        var s = document.createElement("select");
        s.setAttribute("aria-label", o.nom + " " + self.T.de_article + " " + (n + 1));
        s.setAttribute("data-i", o.i);
        o.valeurs.forEach(function (v) {
          var op = document.createElement("option");
          op.value = v; op.textContent = v;
          if (v === a.options[o.i]) op.selected = true;
          s.appendChild(op);
        });
        s.addEventListener("change", function () { a.options[o.i] = s.value; a.touche = true; self.maj(false); });
        ligne.appendChild(s);
      });
      liste.appendChild(ligne);
    });
    details.hidden = etat.q < 2;
  };

  Fiche.prototype.recopier = function () {
    var liste = $("[data-sgp-liste-articles]", this.racine), etat = this.etat;
    etat.articles.forEach(function (a, n) {
      if (a.touche) return;
      a.options = etat.options.slice();
      var ligne = liste && liste.children[n];
      if (!ligne) return;
      $$("select", ligne).forEach(function (s) { s.value = a.options[+s.getAttribute("data-i")]; });
    });
  };

  /* Les lignes que l'ajout enverra : une par variante, quantités regroupées. */
  Fiche.prototype.lignesPanier = function () {
    var self = this, etat = this.etat, parId = {}, ordre = [], manque = false;
    var avecArticles = etat.q > 1 && this.optionsVariables().length && $("[data-sgp-liste-articles]", this.racine);
    var articles = avecArticles ? etat.articles : [{ options: etat.options }];
    articles.forEach(function (a) {
      var v = self.variante(a.options);
      if (!v || !v.dispo) { manque = true; return; }
      var n = avecArticles ? 1 : etat.q;
      if (!parId[v.id]) { parId[v.id] = 0; ordre.push(v.id); }
      parId[v.id] += n;
    });
    return { manque: manque, items: ordre.map(function (id) { return { id: id, quantity: parId[id] }; }) };
  };

  Fiche.prototype.maj = function (choixCouleur) {
    var self = this, form = this.form(), etat = this.etat;
    if (!form) return;
    var v = this.variante(etat.options);
    var base = v ? v.prix : ((this.D.variantes || [])[0] || { prix: 0 }).prix;

    $$(".sgp-palier", form).forEach(function (carte) {
      var inp = $("input", carte);
      var c = calculPalier(base, +inp.value, +inp.getAttribute("data-remise") || 0);
      var zp = $("[data-sgp-prix]", carte), zu = $("[data-sgp-unite]", carte), ze = $("[data-sgp-eco]", carte);
      if (zp) zp.textContent = self.prix(c.total);
      // Le prix à l'unité ne se lit que s'il diffère du prix de la variante : 2 articles
      // ou plus ET une remise réelle. Même règle que sections/sgp-fiche.liquid.
      if (zu) zu.textContent = (+inp.value > 1 && c.economie > 0) ? self.prix(c.unite) + " " + self.T.unite : "";
      if (ze) ze.textContent = c.economie > 0 ? self.prix(c.economie) + " " + self.T.economie : "";
    });
    var calc = calculPalier(base, etat.q, etat.remise);

    $$("[data-sgp-choix]", form).forEach(function (fs) {
      var i = +fs.getAttribute("data-sgp-choix"), b = $("[data-sgp-valeur]", fs);
      if (b) b.textContent = etat.options[i] || "";
      $$("input[data-sgp-option]", fs).forEach(function (inp) {
        var essai = etat.options.slice(); essai[i] = inp.value;
        var w = self.variante(essai);
        var lab = inp.closest("label");
        if (lab) lab.classList.toggle("est-epuise", !w || !w.dispo);
      });
    });

    var lignes = this.lignesPanier();
    var bouton = $("[data-sgp-ajouter]", form);
    if (bouton) {
      var dispo = !lignes.manque && lignes.items.length > 0;
      bouton.disabled = !dispo;
      bouton.textContent = dispo ? (this.D.bouton + " \u00b7 " + this.prix(calc.total)) : this.T.epuise;
    }
    var retour = $("[data-sgp-retour]", form);
    if (retour) retour.textContent = lignes.manque && v && v.dispo ? this.T.indispo : "";
    var champId = $("[data-sgp-id]", form), champQ = $("[data-sgp-qte]", form);
    if (champId && v) champId.value = v.id;
    if (champQ) champQ.value = etat.q;

    var rq = $("[data-sgp-resume-q]", this.racine), rp = $("[data-sgp-resume-prix]", this.racine);
    if (rq) rq.textContent = this.nomQuantite(etat.q);
    if (rp) rp.textContent = this.prix(calc.total);

    if (choixCouleur && v) {
      if (v.media) this.montrerMedia(v.media);
      try {
        var u = new URL(window.location.href);
        u.searchParams.set("variant", v.id);
        window.history.replaceState(window.history.state, "", u.toString());
      } catch (e) {}
    }
  };

  /* ── Ajout au panier : une requête, toutes les lignes, puis le tiroir ────── */
  Fiche.prototype.ajouter = function () {
    var self = this, form = this.form();
    var bouton = $("[data-sgp-ajouter]", form), retour = $("[data-sgp-retour]", form);
    var lignes = this.lignesPanier();
    if (lignes.manque || !lignes.items.length) { if (retour) retour.textContent = this.T.indispo; return; }
    if (bouton) bouton.disabled = true;
    var ctrl = typeof AbortController !== "undefined" ? new AbortController() : null;
    var minuterie = setTimeout(function () { if (ctrl) ctrl.abort(); }, 12000);
    window.fetch(racineShopify() + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ items: lignes.items }),
      signal: ctrl ? ctrl.signal : undefined
    }).then(function (r) {
      return r.json().then(function (d) { return { ok: r.ok, d: d }; });
    }).then(function (res) {
      clearTimeout(minuterie);
      if (bouton) bouton.disabled = false;
      if (!res.ok) {
        var detail = res.d && (res.d.description || res.d.message);
        if (retour) retour.textContent = self.T.erreur + (detail ? " " + detail : "");
        return;
      }
      if (retour) retour.textContent = self.T.ajoute;
      document.dispatchEvent(new CustomEvent("sgp:ajoute", { detail: { items: lignes.items } }));
      if (window.SGCart && typeof window.SGCart.open === "function") window.SGCart.open();
      else window.location.href = racineShopify() + "cart";
    }).catch(function () {
      clearTimeout(minuterie);
      if (bouton) bouton.disabled = false;
      if (retour) retour.textContent = self.T.erreur;
    });
  };

  /* ── Galerie : vignettes et défilement au doigt restent synchronisés ────── */
  Fiche.prototype.initGalerie = function () {
    var piste = $("[data-sgp-piste]", this.racine), vignettes = $$("[data-sgp-vignette]", this.racine);
    if (!piste) return;
    vignettes.forEach(function (b) {
      b.addEventListener("click", function () {
        piste.scrollTo({ left: +b.getAttribute("data-sgp-vignette") * piste.clientWidth, behavior: reduit ? "auto" : "smooth" });
      });
    });
    var liste = $("[data-sgp-vignettes]", this.racine), suivante = $("[data-sgp-suivante]", this.racine);
    var courante = function () { return Math.round(piste.scrollLeft / Math.max(1, piste.clientWidth)); };
    // La vignette active reste visible dans sa rangée, sans jamais faire défiler la page.
    var montrerVignette = function (i) {
      var b = vignettes[i];
      if (!liste || !b) return;
      var li = b.parentNode, g = li.offsetLeft, d = g + li.offsetWidth, reserve = suivante ? 52 : 0;
      if (g < liste.scrollLeft) liste.scrollLeft = g;
      else if (d > liste.scrollLeft + liste.clientWidth - reserve) liste.scrollLeft = d - liste.clientWidth + reserve;
    };
    // La flèche : photo suivante, puis retour à la première après la dernière.
    if (suivante) suivante.addEventListener("click", function () {
      var n = $$("[data-sgp-vue]", piste).length;
      if (n < 2) return;
      piste.scrollTo({ left: ((courante() + 1) % n) * piste.clientWidth, behavior: reduit ? "auto" : "smooth" });
    });
    var attente = 0;
    piste.addEventListener("scroll", function () {
      cancelAnimationFrame(attente);
      attente = requestAnimationFrame(function () {
        var i = courante();
        vignettes.forEach(function (b, j) { b.setAttribute("aria-current", j === i ? "true" : "false"); });
        montrerVignette(i);
      });
    }, { passive: true });
  };

  Fiche.prototype.montrerMedia = function (idMedia) {
    var piste = $("[data-sgp-piste]", this.racine);
    if (!piste) return;
    var vues = $$("[data-sgp-vue]", piste);
    for (var i = 0; i < vues.length; i++) {
      if (+vues[i].getAttribute("data-media") === +idMedia) {
        piste.scrollTo({ left: i * piste.clientWidth, behavior: reduit ? "auto" : "smooth" });
        return;
      }
    }
  };

  /* ── Date d'expédition : heure limite, jours de préparation, jours fermés ── */
  Fiche.prototype.initExpedition = function () {
    var zone = $("[data-sgp-expedition]", this.racine), cible = zone && $("[data-sgp-date]", zone);
    var x = this.D.expedition;
    if (!zone || !cible || !x) return;
    var d = new Date();
    function ferme(j) { var w = j.getDay(); return (w === 6 && !x.samedi) || (w === 0 && !x.dimanche); }
    if (d.getHours() >= (+x.heureLimite || 0)) d.setDate(d.getDate() + 1);
    var garde = 0;
    while (ferme(d) && garde++ < 7) d.setDate(d.getDate() + 1);
    for (var n = 0; n < (+x.joursPreparation || 0); n++) {
      d.setDate(d.getDate() + 1);
      garde = 0;
      while (ferme(d) && garde++ < 7) d.setDate(d.getDate() + 1);
    }
    var langue = (this.D.langue || "fr").indexOf("en") === 0 ? "en-GB" : "fr-FR";
    try { cible.textContent = new Intl.DateTimeFormat(langue, { weekday: "long", day: "numeric", month: "long" }).format(d); }
    catch (e) { cible.textContent = d.toLocaleDateString(); }
    zone.hidden = false;
  };

  /* ── Barre collante ────────────────────────────────────────────────────────
     Pas d'IntersectionObserver : un saut par-dessus le bouton (ancre, défilement
     rapide, retour de page) ne déclenche aucun rappel, la barre restait cachée
     (constaté au rendu le 28/09). Un écouteur passif, une lecture par image.
     ⚠️ Sur Horizon, la FENÊTRE ne défile jamais : html et body sont figés à la
     hauteur de l'écran et c'est `.page-wrapper` qui défile (base.css). Un écouteur
     posé sur window n'entend donc rien, et la barre ne sortait jamais (vu au rendu
     de l'aperçu du 28/09). L'écoute se fait en CAPTURE sur document : elle entend le
     défilement de n'importe quel conteneur, fenêtre comprise. */
  Fiche.prototype.initBarre = function () {
    var racine = this.racine;
    var barre = $("[data-sgp-barre]", racine);
    if (!barre) return;
    if (!document.querySelector(".sgp-espace-barre")) {
      var espace = document.createElement("div");
      espace.className = "sgp-espace-barre";
      espace.setAttribute("aria-hidden", "true");
      (document.querySelector(".page-wrapper") || document.body).appendChild(espace);
    }
    var attente = 0;
    function majBarre() {
      attente = 0;
      var bouton = $("[data-sgp-ajouter]", racine);
      barre.classList.toggle("est-visible", !!bouton && bouton.getBoundingClientRect().bottom < 0);
    }
    function demander() { if (!attente) attente = requestAnimationFrame(majBarre); }
    document.addEventListener("scroll", demander, { passive: true, capture: true });
    window.addEventListener("scroll", demander, { passive: true });
    window.addEventListener("resize", demander);
    window.addEventListener("pageshow", demander);
    majBarre();
  };

  /* ── Guide des tailles et calculateur ───────────────────────────────────── */
  function intervalle(texte) {
    var s = String(texte || "").replace(/,/g, ".").trim();
    var m = s.match(/(\d+(?:\.\d+)?)\s*(?:-|\u2013|\u2014|à|a|to|\/|~)\s*(\d+(?:\.\d+)?)/i);
    if (m) { var a = +m[1], b = +m[2]; return a <= b ? [a, b] : [b, a]; }
    var u = s.match(/^(\d+(?:\.\d+)?)\s*(?:cm)?$/i);
    return u ? [+u[1], +u[1]] : null;
  }
  /* Lit le tableau RENDU : les colonnes chiffrées en cm deviennent des mesures.
     Une colonne n'est retenue que si son titre dit « cm », ou si TOUTES ses cases
     sont des intervalles plausibles pour un corps (20 à 250) : une colonne de
     pointures ou de tailles européennes ne devient jamais un curseur. */
  function lireTableau(table) {
    if (!table || !table.tHead || !table.tBodies.length) return null;
    var entetes = $$("th", table.tHead).map(function (c) { return c.textContent.trim(); });
    var lignes = $$("tr", table.tBodies[0]).map(function (r) { return $$("th,td", r).map(function (c) { return c.textContent.trim(); }); })
      .filter(function (l) { return l.length > 1 && l[0]; });
    if (lignes.length < 2) return null;
    var mesures = [];
    for (var j = 1; j < entetes.length && mesures.length < 2; j++) {
      var titre = entetes[j] || "";
      if (/inch|pouce|\bin\b|"|lbs?\b|kg\b/i.test(titre)) continue;
      var enCm = /\bcm\b/i.test(titre);
      var vals = lignes.map(function (l) { return intervalle(l[j]); });
      if (vals.some(function (x) { return !x; })) continue;
      var plausibles = vals.every(function (x) { return x[0] >= 20 && x[1] <= 250; });
      var intervalles = vals.every(function (x) { return x[1] > x[0]; });
      if (!enCm && !(plausibles && intervalles)) continue;
      var bas = Math.min.apply(null, vals.map(function (x) { return x[0]; }));
      var haut = Math.max.apply(null, vals.map(function (x) { return x[1]; }));
      var milieu = vals[Math.floor((vals.length - 1) / 2)];
      mesures.push({
        j: j,
        nom: titre.replace(/\s*\(\s*cm\s*\)\s*/i, "").replace(/\s*en\s+cm\s*$/i, "").trim() || titre,
        min: Math.floor(bas - 6), max: Math.ceil(haut + 6),
        defaut: Math.round((milieu[0] + milieu[1]) / 2),
        vals: vals
      });
    }
    if (!mesures.length) return null;
    return { tailles: lignes.map(function (l) { return l[0]; }), mesures: mesures };
  }

  Fiche.prototype.initGuide = function () {
    var self = this, racine = this.racine, guide = $("[data-sgp-guide]", racine);
    var ouvreur = $("[data-sgp-ouvrir-guide]", racine);
    if (!guide || !ouvreur) return;
    ouvreur.addEventListener("click", function () {
      if (typeof guide.showModal === "function") guide.showModal(); else guide.setAttribute("open", "");
    });
    var fermer = function () { if (typeof guide.close === "function") guide.close(); else guide.removeAttribute("open"); };
    var bf = $("[data-sgp-fermer-guide]", guide);
    if (bf) bf.addEventListener("click", fermer);
    guide.addEventListener("click", function (e) { if (e.target === guide) fermer(); });

    var table = $("[data-sgp-tableau]", guide), G = lireTableau(table);
    var calcul = $("[data-sgp-calcul]", guide);
    if (!G || !calcul) return;
    var T = this.T, valeurs = {}, zone = $("[data-sgp-mesures]", guide), lignesDom = table ? $$("tbody tr", table) : [];
    G.mesures.forEach(function (m, k) {
      valeurs[k] = m.defaut;
      var id = "sgp-m-" + (racine.getAttribute("data-section") || "x") + "-" + k;
      var bloc = document.createElement("div");
      bloc.className = "sgp-mesure";
      var tete = document.createElement("div"); tete.className = "sgp-mesure__tete";
      var lab = document.createElement("label"); lab.setAttribute("for", id); lab.textContent = m.nom;
      var sortie = document.createElement("output"); sortie.setAttribute("for", id);
      var nb = document.createTextNode(String(m.defaut)); var unite = document.createElement("small"); unite.textContent = "cm";
      sortie.appendChild(nb); sortie.appendChild(unite);
      tete.appendChild(lab); tete.appendChild(sortie);
      var reglage = document.createElement("div"); reglage.className = "sgp-mesure__reglage";
      function pas(sens, libelle, icone) {
        var b = document.createElement("button");
        b.type = "button"; b.className = "sgp-pas"; b.setAttribute("aria-label", m.nom + " : " + libelle);
        b.innerHTML = '<svg class="sgp-icone" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="' + icone + '"/></svg>';
        b.addEventListener("click", function () { poser(valeurs[k] + sens); });
        return b;
      }
      var curseur = document.createElement("input");
      curseur.type = "range"; curseur.id = id; curseur.min = m.min; curseur.max = m.max; curseur.step = 1; curseur.value = m.defaut;
      function poser(v) {
        v = Math.max(m.min, Math.min(m.max, Math.round(v)));
        valeurs[k] = v; curseur.value = v; nb.nodeValue = String(v);
        curseur.setAttribute("aria-valuetext", v + " " + T.centimetres);
        calculer();
      }
      curseur.addEventListener("input", function () { poser(+curseur.value); });
      reglage.appendChild(pas(-1, T.cm_moins, "M5 12h14"));
      reglage.appendChild(curseur);
      reglage.appendChild(pas(1, T.cm_plus, "M12 5v14M5 12h14"));
      bloc.appendChild(tete); bloc.appendChild(reglage);
      zone.appendChild(bloc);
    });

    /* Règle : pour chaque mesure, la plus petite taille dont le maximum la contient ;
       on garde la plus grande des tailles trouvées (entre deux, la plus grande). */
    function indice(k, v) {
      var vals = G.mesures[k].vals;
      for (var i = 0; i < vals.length; i++) if (v <= vals[i][1]) return i;
      return -1;
    }
    var proposee = "";
    var btn = $("[data-sgp-choisir-taille]", guide), texte = $("[data-sgp-res-texte]", guide), grand = $("[data-sgp-res-taille]", guide);
    function calculer() {
      var idx = G.mesures.map(function (m, k) { return indice(k, valeurs[k]); });
      lignesDom.forEach(function (tr) { tr.classList.remove("est-conseillee"); });
      if (idx.indexOf(-1) >= 0) {
        grand.textContent = "?"; btn.hidden = true; proposee = "";
        texte.textContent = T.hors_tableau;
        return;
      }
      var i = Math.max.apply(null, idx);
      proposee = G.tailles[i];
      grand.textContent = proposee;
      btn.textContent = T.choisir_taille + " " + proposee;
      btn.hidden = !self.radioTaille(proposee);
      if (lignesDom[i]) lignesDom[i].classList.add("est-conseillee");
      var tous = idx.every(function (x) { return x === idx[0]; });
      if (G.mesures.length === 1) texte.textContent = T.correspond_une + " " + proposee + ".";
      else if (tous) texte.textContent = T.correspond_toutes + " " + proposee + ".";
      else texte.textContent = G.mesures.map(function (m, k) { return (k ? T.votre.toLowerCase() : T.votre) + " " + m.nom.toLowerCase() + " " + T.correspond_au + " " + G.tailles[idx[k]]; }).join(", ")
        + ". " + T.plus_grande + " " + proposee + ", " + T.a_l_aise;
    }
    calculer();
    calcul.hidden = false;
    btn.addEventListener("click", function () {
      var r = self.radioTaille(proposee);
      if (!r) return;
      r.checked = true;
      r.__sgpCalcul = true;
      r.dispatchEvent(new Event("change", { bubbles: true }));
      var cs = $("[data-sgp-conseil]", racine);
      if (cs) cs.hidden = false;
      fermer();
      try { r.focus({ preventScroll: false }); } catch (e) { r.focus(); }
    });
  };

  /* Le bouton radio de la taille proposée : même nom, sinon un nom qui commence pareil. */
  Fiche.prototype.radioTaille = function (nom) {
    if (!nom) return null;
    var radios = $$("[data-sgp-taille] input[data-sgp-option]", this.racine), bas = nom.toLowerCase();
    for (var i = 0; i < radios.length; i++) if (radios[i].value.toLowerCase() === bas) return radios[i];
    for (var j = 0; j < radios.length; j++) if (radios[j].value.toLowerCase().indexOf(bas + " ") === 0) return radios[j];
    return null;
  };

  /* ════════════════ Ce qui vaut pour toute la page ════════════════ */

  /* L'envoi du formulaire d'offre : pris en phase de CAPTURE sur window, donc AVANT
     l'écouteur du tiroir (posé en capture sur document), qui ne sait envoyer qu'une
     variante. Le formulaire se retrouve par la cible, jamais par form.id : un champ
     nommé « id » masque cette propriété (leçon du 23/09). */
  window.addEventListener("submit", function (e) {
    var form = e.target && e.target.closest ? e.target.closest("[data-sgp-offre]") : null;
    if (!form) return;
    var racine = form.closest("[data-sgp-fiche]"), fiche = racine && racine.__sgp;
    if (!fiche) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    fiche.ajouter();
  }, true);

  /* Les boutons qui remontent à l'offre : défilement doux, puis le palier coché
     prend le focus. Sans offre sur la page, ils se retirent (un bouton qui ne mène
     nulle part est pire que pas de bouton). */
  document.addEventListener("click", function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href="#sgp-offre"]') : null;
    if (!a) return;
    var offre = document.getElementById("sgp-offre");
    if (!offre) return;
    e.preventDefault();
    offre.scrollIntoView({ behavior: reduit ? "auto" : "smooth", block: "start" });
    setTimeout(function () {
      var c = offre.querySelector(".sgp-palier input:checked") || offre.querySelector("[data-sgp-ajouter]");
      if (c) { try { c.focus({ preventScroll: true }); } catch (x) { c.focus(); } }
    }, reduit ? 0 : 450);
  });
  function retirerLiensSansOffre() {
    if (document.getElementById("sgp-offre")) return;
    $$("[data-sgp-vers-offre]").forEach(function (a) { a.hidden = true; });
  }

  /* ── Vidéos à la demande ──────────────────────────────────────────────── */
  function initVideos() {
    var videos = $$("video[data-sgp-video]");
    if (!videos.length) return;
    function lancer(v) {
      if (!v.getAttribute("src") && v.getAttribute("data-src")) { v.setAttribute("src", v.getAttribute("data-src")); v.load(); }
      videos.forEach(function (autre) { if (autre !== v && !autre.paused) autre.pause(); });
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    }
    videos.forEach(function (v) {
      var bouton = v.parentNode && $("[data-sgp-lecture]", v.parentNode);
      v.addEventListener("play", function () { if (bouton) bouton.hidden = true; });
      v.addEventListener("pause", function () { if (bouton) bouton.hidden = false; });
      v.addEventListener("click", function () { if (v.paused) lancer(v); else v.pause(); });
      if (bouton) bouton.addEventListener("click", function () { v.__sgpVoulue = true; lancer(v); });
    });
    if (!("IntersectionObserver" in window)) return;
    var obs = new IntersectionObserver(function (entrees) {
      entrees.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting && en.intersectionRatio >= 0.5) { if (!reduit || v.__sgpVoulue) lancer(v); }
        else if (!v.paused) v.pause();
      });
    }, { threshold: [0, 0.5] });
    videos.forEach(function (v) { obs.observe(v); });
  }

  /* ── La bande de photos et vidéos (V2, lot 2) ──────────────────────────────
     Au doigt, elle défile seule. À la souris, une bande horizontale ne défile pas :
     deux flèches, montrées seulement quand la bande dépasse, éteintes aux deux bouts. */
  function initBandes() {
    $$("[data-sgp-bande]").forEach(function (bande) {
      if (bande.__sgp) return;
      bande.__sgp = true;
      var boite = bande.parentNode;
      var prec = $("[data-sgp-bande-prec]", boite), suiv = $("[data-sgp-bande-suiv]", boite);
      if (!prec || !suiv) return;
      function etat() {
        var deborde = bande.scrollWidth > bande.clientWidth + 2;
        prec.hidden = suiv.hidden = !deborde;
        prec.disabled = bande.scrollLeft <= 2;
        suiv.disabled = bande.scrollLeft + bande.clientWidth >= bande.scrollWidth - 2;
      }
      function aller(sens) { bande.scrollBy({ left: sens * Math.round(bande.clientWidth * 0.8), behavior: reduit ? "auto" : "smooth" }); }
      prec.addEventListener("click", function () { aller(-1); });
      suiv.addEventListener("click", function () { aller(1); });
      bande.addEventListener("scroll", etat, { passive: true });
      window.addEventListener("resize", etat);
      $$("img", bande).forEach(function (i) { if (!i.complete) i.addEventListener("load", etat); });
      etat();
    });
  }

  /* ── Les avis (V2, lot 3) ──────────────────────────────────────────────────
     La piste défile par initBandes (mêmes attributs, flèches sous les cartes). Ici, le texte
     long : replié sur huit lignes par la feuille, « Lire la suite » n'apparaît que s'il est
     VRAIMENT coupé, mesuré après le chargement des polices et à chaque changement de largeur. */
  function initAvis() {
    $$("[data-sgp-avis-suite]").forEach(function (bouton) {
      if (bouton.__sgp) return;
      bouton.__sgp = true;
      var carte = bouton.parentNode, texte = carte && $("[data-sgp-avis-texte]", carte);
      if (!texte) return;
      function mesure() {
        if (carte.classList.contains("est-deplie")) return;
        bouton.hidden = !(texte.scrollHeight > texte.clientHeight + 2);
      }
      bouton.addEventListener("click", function () {
        var ouvert = carte.classList.toggle("est-deplie");
        bouton.setAttribute("aria-expanded", ouvert ? "true" : "false");
        bouton.textContent = bouton.getAttribute(ouvert ? "data-reduire" : "data-suite") || bouton.textContent;
        if (!ouvert) mesure();
      });
      window.addEventListener("resize", mesure);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(mesure, function () {});
      mesure();
    });
  }

  function demarrer() {
    $$("[data-sgp-fiche]").forEach(function (r) { if (!r.__sgp) new Fiche(r); });
    retirerLiensSansOffre();
    initVideos();
    initBandes();
    initAvis();
  }

  window.SgpFiche = { prix: prix, calculPalier: calculPalier, intervalle: intervalle, demarrer: demarrer };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", demarrer);
  else demarrer();

  /* Éditeur de thème : une section rechargée repart de zéro. */
  document.addEventListener("shopify:section:load", function () { demarrer(); });
})();
